(() => {
  if (window.ameliaProductInitialized) return;
  window.ameliaProductInitialized = true;
  const reduceMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.addEventListener('click', event => {
    const button = event.target.closest?.('.amp-product [data-cart-bar-scroll]');
    if (!button) return;
    const product = button.closest('.amp-product');
    const target = product.querySelector('[data-amp-options-anchor]') || product.querySelector('[data-product-variants]') || product.querySelector('[data-product-form]');
    if (!target) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const offset = window.innerHeight * 0.3;
    const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset);
    window.scrollTo({top, behavior:reduceMotion() ? 'instant' : 'smooth'});
  }, true);
  const setup = (scope = document) => {
    scope.querySelectorAll('.amp-product').forEach(product => {
      if (product.dataset.ampStickyReady) return;
      const button = product.querySelector('.product__content [data-add-to-cart]');
      if (!button) return;
      product.dataset.ampStickyReady = 'true';
      new IntersectionObserver(entries => {
        product.classList.toggle('amp-native-button-visible', entries[0].isIntersecting);
      }, {threshold:0}).observe(button);
    });
    scope.querySelectorAll('[data-amp-details] details').forEach(details => {
      if (details.dataset.ampReady) return;
      details.dataset.ampReady = 'true';
      const summary = details.querySelector('summary');
      const body = details.querySelector('.amp-details__body');
      let animation;
      let targetOpen = details.open;
      summary.setAttribute('aria-expanded',String(targetOpen));
      summary.addEventListener('click', event => {
        event.preventDefault();
        const start = details.getBoundingClientRect().height;
        targetOpen = !targetOpen;
        animation?.cancel();
        summary.setAttribute('aria-expanded',String(targetOpen));
        details.classList.toggle('amp-expanding',targetOpen);
        if (reduceMotion()) {
          details.open = targetOpen;
          details.style.removeProperty('overflow');
          animation = null;
          return;
        }
        details.open = true;
        const closedHeight = summary.getBoundingClientRect().height + parseFloat(getComputedStyle(details).borderTopWidth) + parseFloat(getComputedStyle(details).borderBottomWidth);
        const end = targetOpen ? closedHeight + body.getBoundingClientRect().height : closedHeight;
        details.style.overflow = 'hidden';
        const currentAnimation = details.animate([{height:start+'px'},{height:end+'px'}],{duration:360,easing:'cubic-bezier(.22,.61,.36,1)',fill:'both'});
        animation = currentAnimation;
        currentAnimation.onfinish = () => {
          details.open = targetOpen;
          currentAnimation.cancel();
          details.style.removeProperty('overflow');
          animation = null;
        };
      });
    });
    scope.querySelectorAll('[data-amp-recommendations]').forEach(section => {
      const bind = () => {
        const track = section.querySelector('[data-amp-track]');
        const prev = section.querySelector('[data-amp-prev]');
        const next = section.querySelector('[data-amp-next]');
        if (!track || track.dataset.ampReady) return;
        track.dataset.ampReady = 'true';
        const update = () => {prev.disabled = track.scrollLeft < 2;next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth-2;};
        [prev,next].forEach((button,i) => button.addEventListener('click',() => track.scrollBy({left:(i ? 1:-1)*track.clientWidth,behavior:reduceMotion()?'auto':'smooth'})));
        track.addEventListener('scroll',update,{passive:true});
        new ResizeObserver(update).observe(track);
        update();
      };
      bind();
      if (section.dataset.ampLoaded) return;
      section.dataset.ampLoaded = 'true';
      fetch(section.dataset.url).then(response => {if (!response.ok) throw new Error('Recommendations unavailable');return response.text();}).then(html => {
        const parsed = new DOMParser().parseFromString(html,'text/html');
        const content = parsed.querySelector('[data-amp-related-content]');
        if (content?.querySelector('.amc-card')) {section.replaceChildren(content);bind();}
      }).catch(() => {});
    });
  };
  setup();
  document.addEventListener('shopify:section:load',event => setup(event.target));
})();
